import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { MontorFeed } from "@/components/drift/MontorFeed";
import { useMontorar } from "@/components/drift/Dialogs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/* /drift/montor – the technician's phone view. Office roles can pick which technician to see as. */
export default function MontorHome() {
  const { user } = useAuth();
  const isMontor = user.role === "montor";
  const montorar = useMontorar();
  const [viewAs, setViewAs] = useState("");
  useEffect(() => { if (!isMontor && montorar.length && !viewAs) setViewAs(montorar[0].id); }, [montorar, isMontor, viewAs]);
  const viewName = isMontor ? user.name : montorar.find((m) => m.id === viewAs)?.name || user.name;

  const header = !isMontor ? (
    <div className="mt-3">
      <Select value={viewAs} onValueChange={setViewAs}>
        <SelectTrigger className="h-10 rounded-lg bg-card" data-testid="montor-view-as-select"><SelectValue placeholder="Vis som montør …" /></SelectTrigger>
        <SelectContent>{montorar.map((m) => <SelectItem key={m.id} value={m.id}>{m.name} – {m.title}</SelectItem>)}</SelectContent>
      </Select>
      <p className="mt-1 text-[11.5px] text-muted-foreground">Du ser montørvisninga slik montøren ser henne på telefonen.</p>
    </div>
  ) : null;

  return <MontorFeed mine={isMontor} assignedTo={isMontor ? null : viewAs || null} name={viewName} header={header} />;
}
